export default __webpack_public_path__ + "static/main3-814b12d0ec9015f6e9a81a02d6c92ecf.jpg";